import { apiGetCasinoTypes, apiGetCasinos, apiGetFilteredCasinos, apiGetCasinosViews, apiGetMore } from '@/api';
import * as types from '@/store/mutation-types';

// Models
import PAGINATION from '@/store/models/pagination';

// Services
import { mapEnabledToSlug } from '@/store/services/mapEnabledToSlug';

// initial state
const state = {
  all: {
    data: [],
    meta: PAGINATION
  },

  popular: [],

  totalViews: null,

  casinoTypes: null,
};

// mutations
const mutations = {
  [types.RECEIVED_POPULAR_CASINOS] (state, data) {
    state.popular = data.data;
  },

  [types.RECEIVED_CASINOS] (state, data) {
    state.all.data = data.data;
    state.all.meta = data.meta;
  },

  [types.RECEIVED_CASINOS_TOTAL_VIEWS] (state, views) {
    state.totalViews = views;
  },

  [types.RECEIVED_CASINO_TYPES] (state, types) {
    state.casinoTypes = types.data;
  },

  [types.APPEND_CASINOS] (state, data) {
    data.data.forEach(function(obj) {
      state.all.data.push(obj);
    });

    state.all.meta = data.meta;
  }
};

const actions = {
  getCasinosTypes: ({ commit }, args = {}) => {
    return apiGetCasinoTypes(args).then(({ data }) => {
      // success
      commit(types.RECEIVED_CASINO_TYPES, data);
    })
    .catch((error) => {
      console.log(error);
    });
  },

  getPopularCasinos: ({ commit }, args = { limit: 5, is_ordered: true, order: 'order', include: 'stats' }) => {
    return apiGetCasinos(args).then(({ data }) => {
      // success
      commit(types.RECEIVED_POPULAR_CASINOS, data);
    })
    .catch((error) => {
      console.log(error);
    });
  },

  getCasinos: ({ commit }, args = { limit: 16 } ) => {
    return apiGetCasinos(args).then(({ data }) => {
      // success
      commit(types.RECEIVED_CASINOS, data);
    })
    .catch((error) => {
      console.log(error);
    });
  },

  getCasinosViews: ({ commit }) => {
    return apiGetCasinosViews()
      .then(({ data }) => {
        // success
        commit(types.RECEIVED_CASINOS_TOTAL_VIEWS, data);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  getMoreCasinos: ({ commit }, url) => {
    return apiGetMore(url).then(({ data }) => {
        commit(types.APPEND_CASINOS, data);
      })
      .catch((error) => {
        console.log(error);
      });
  }
};

const getters = {
  casinos (state) {
    return state;
  },

  casinosPopular (state) {
    return state.popular;
  },

  casinosTotalViews (state) {
    return state.totalViews;
  },

  casinoTypes (state) {
    return state.casinoTypes;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/store/modules/casinos.js